import React from 'react';

const b2eStyle = {
  backgroundColor: '#4571D0',
  width: 46,
  height: 30,
  display: 'inline-block',
  color: '#F5F7F9',
  borderRadius: 3,
  textAlign: 'center',
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'uppercase',
  padding: 7
};

const b2eSVG = () =>
  <span style={b2eStyle}>
    b2e
  </span>;

export default b2eSVG;



// WEBPACK FOOTER //
// ./src/svg/b2eSVG.js